import _get from "lodash/get";
import queryString from "../plugins/query-string-object";

import { QUOTE_STEPS } from "../app";

export default {
    props: {
        value: {
            type: Object,
            required: true
        },
        step: {
            type: Object | null,
            required: true
        },
        verified: {
            type: Boolean | null,
            required: true,
            default: false
        },
        lead: {
            default: false
        },
        settings: {
            type: Object,
            default: () => ({})
        },
        constants: {
            type: Object | null,
            default: () => ({})
        }
    },

    data() {
        return {
            loading: false,
            form: this.value,
            errors: this.$api.errors(),
            returnToken: window.yna.returnToken,
            quote_request_id: window.yna.quote
                ? window.yna.quote.request_id
                : null,
            subSteps: [],
            currentSubStep: 0,
            quoteType: window.yna.quote
                ? window.yna.quote.type
                : window.yna.quoteType,
            quoteSteps: window.yna.quote
                ? QUOTE_STEPS[window.yna.quote.type]
                : null
        };
    },

    watch: {
        value() {
            this.form = this.value;
        },
        currentSubStep() {
            this.emitSubStep();
        },
        form: {
            deep: true,
            handler() {
                this.$emit("input", this.form);
            }
        }
    },

    methods: {
        checkHashSubStep() {
            let hash = window.location.hash.substring(2);
            let parameters = hash.split("/");
            let query = hash.split("?");
            query = query.pop();
            hash = parameters.shift();

            if (query) {
                query = queryString.parse(query);

                if (query.subStep) {
                    this.currentSubStep = parseInt(query.subStep);

                    if (this.currentSubStep > this.subSteps.length - 1) {
                        this.currentSubStep = 0;
                    }

                    this.updateBackground();
                }
            }
        },

        updateBackground() {
            if (!this.verified) {
                return;
            }

            this.$emit("background", this.subSteps[this.currentSubStep]);
        },

        async validateStep() {
            const fieldsToValidate = this.subStepFields.fields;

            const formFields = this.form[this.stepName];

            const filteredFormFields = Object.keys(formFields)
                .filter(key => fieldsToValidate.includes(key))
                .reduce((obj, key) => {
                    obj[key] = formFields[key];
                    return obj;
                }, {});

            this.loading = true;

            let overrideValidation = {};

            if (this.subStepFields.overrideValidation) {
                overrideValidation.validation = this.subStepFields.overrideValidation;
            }

            let url = `quote/${this.quote_request_id}/validate/${this.$options.name}`;

            if (this.returnToken) {
                url += `?return_token=${this.returnToken}`;
            }

            let response = await this.$api.post(url, {
                ...filteredFormFields,
                ...overrideValidation,
                ...((this.stepName === "TravelQuoteSelectWhere" ||
                    this.stepName === "TravelQuoteMedicalQuestions" ||
                    this.stepName === "TravelQuoteTripInfo") && {
                    validation: true
                })
            });

            this.errors = response.errors();

            if (response.hasErrors()) {
                this.loading = false;
                return false;
            }

            this.loading = false;
            return true;
        },

        async prev() {
            if (this.loading) {
                return;
            }

            if (this.currentSubStep > 0) {
                this.currentSubStep -= 1;
            } else {
                console.log("go to previous component step");
                this.$emit("prev");
            }

            this.updateBackground();
        },

        async next(subStep = null) {
            if (this.loading) {
                return;
            }

            const validated = await this.validateStep();

            if (!validated) {
                return;
            }

            // Move to next sub step if exists
            if (this.nextSubStep()) {
                return;
            }

            if (this.step.submitForm) {
                this.$emit("submit");
                return;
            }

            // Only move to the next component step if all sub steps have been finished
            this.currentSubStep = 0;

            this.$emit("next");
        },

        emitSubStep() {
            this.$emit("update_sub_step", this.currentSubStep);
        },

        nextSubStep() {
            if (this.currentSubStep < this.subSteps.length - 1) {
                this.currentSubStep += 1;
                this.updateBackground();

                return true;
            }

            return false;
        },

        trans(key) {
            return _get(this.step.i18n, key);
        },

        async serverValidation() {
            return await this.$api.get(
                "quote/validate/step/" + this.$options.name
            );
        }
    },

    created() {
        if (!this.verified) {
            return;
        }

        window.addEventListener("hashchange", () => {
            this.checkHashSubStep();
        });

        this.checkHashSubStep();
    },

    mounted() {
        this.updateBackground();

        this.$emit("update_sub_step", this.currentSubStep);

        this.$on("set_prev_substep", (step = null) => {
            this.currentSubStep = step ? step : this.subSteps.length - 1;
        });

        this.$on("update_sub_step", subStep => {
            this.currentSubStep = subStep;
            this.updateBackground();
        });
    },

    computed: {
        isValid() {
            return true;
        },
        stepName() {
            return this.$options.name;
        },
        subStep() {
            return this.subSteps[this.currentSubStep];
        },
        subStepFields() {
            return this.step && this.step.step_fields[this.subStep];
        },
        stepFormFields() {
            return this.form[this.stepName];
        },
        disabledConditions() {
            return !this.canMoveNext;
        }
    }
};
